module.exports = __webpack_public_path__ + "static/media/back_filled.5a4b88a3.svg";